import { render, staticRenderFns } from "./DeletedАdministrativePositions.vue?vue&type=template&id=7ea1f74d"
import script from "./DeletedАdministrativePositions.vue?vue&type=script&lang=js"
export * from "./DeletedАdministrativePositions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports